<!-- PurposeBanner.vue -->
<template>
  <!-- El :style se genera a partir de la prop 'image' -->
  <section class="purpose-banner" :style="bgStyle">
    <div class="content">
      <h2 class="title-quienes-somos">
        Únete al <br />
        equipo
      </h2>

      <p class="description-quienes-somos">
        Postula a la posición que más te guste, nosotros/as te capacitaremos y así iniciarás tu carrera
      </p>
    </div>
  </section>
</template>

<script>
// import recognitionImage from "@/assets/newlanding/Landing/background-quienes-somos.jpg";
import employee from "../../../assets/newlanding/Landing/employee.png";
export default {
  name: "PurposeBanner",
  computed: {
    bgStyle() {
      return {
        backgroundImage: `url(${employee})`,
      };
    },
  },
};
</script>

<style scoped>
/* --- Layout base --- */
.purpose-banner {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 330px;
  background-position: center;
  background-size: cover;
  border-radius: 8px;
  overflow: hidden;
}

/* Degradado oscuro de izquierda a derecha */
.purpose-banner::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0.85) 0%,
    rgba(0, 0, 0, 0.6) 35%,
    rgba(0, 0, 0, 0.05) 70%,
    transparent 85%
  );
}

/* --- Contenido --- */
.content {
  position: relative; /* por delante del ::before */
  z-index: 1;
  max-width: 320px;
  margin-left: 48px;
  color: #ffffff;
}

.title-quienes-somos {
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 1rem;
}

.description-quienes-somos {
  font-size: 0.9375rem;
  line-height: 1.45;
  margin-bottom: 1.5rem;
}

.cta {
  padding: 0.75rem 1.5rem;
  background: #ffffff;
  color: #0f0f72; /* morado aproximado del mockup */
  border: none;
  border-radius: 4px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}

.cta:hover {
  background: #5b4bff;
  color: #ffffff;
}

/* --- Diseño responsivo --- */
@media (max-width: 768px) {
  .purpose-banner {
    min-height: 420px;
    align-items: flex-end; /* contenido abajo */
  }

  /* Cambiamos degradado para que nazca arriba */
  .purpose-banner::before {
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.85) 0%,
      rgba(0, 0, 0, 0.6) 40%,
      rgba(0, 0, 0, 0.2) 75%,
      transparent 100%
    );
  }

  .content {
    margin: 0 1rem 6rem; /* centramos con margen lateral */
  }

  .title-quienes-somos {
    font-size: 1.75rem;
  }
}
</style>
